var map = {
	"./SON_hexagon_cropped.svg": 3158,
	"./SON_logo_favicon_browser@2x.png": 3205,
	"./logo_nexus_generic.svg": 8532,
	"./sonatype-logo-with-hexagon.png": 4691,
	"./tile_bg.png": 4364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2860;